/** The site's default tab title; also <SEO>'s default `title`. Kept out of
 * SEO.tsx so components that only need the constant don't depend on a module
 * many tests replace with a stub. */
export const DEFAULT_PAGE_TITLE = 'AKIVA | AI Engineering & Strategy Consulting';
